  
export const GETKITCHEN = 'GET_KITCHEN_STAFF'
export const UPDATEKITCHEN = 'UPDATE_KITCHEN_STAFF'

export const GETINNER = 'GET_INNER_STAFF'
export const UPDATEINNER = 'UPDATE_INNER_STAFF'

export const GETOUTER = 'GET_OUTER_STAFF'
export const UPDATEOUTER = 'UPDATE_OUTER_STAFF'